import { DbMongoBaseInfos } from "./db-mongo-base-infos";

import { OrderProductType } from "./order-product-type";
import { DbMetadataUsageInfos } from "./db-metadata-usage-infos";
import { DbDeliveryBroadcasterProfileIdentityInfos } from "./db-delivery-broadcaster-profile-identity-infos";
import { DbMetadataFieldExclusionsInfos } from "./db-metadata-field-exclusions-infos";
import { DbMetadataFieldMappingInfos } from "./db-metadata-field-mapping-infos";
import { immerable } from "immer";

export class DbDeliveryBroadcasterInfos extends DbMongoBaseInfos {
  [immerable] = true;
  enabled: boolean | null = null;
  isAutomatedPipeline: boolean | null = null;
  platformId: number | null = 0;
  productType: OrderProductType | null = OrderProductType.TranscodeByProfile;
  externalId: string | null = null;
  name: string | null = null;
  description: string | null = null;
  localizationTerritoryCode: string | null = null;
  serviceDescription: string | null = null;
  documentsFolder: string | null = null;
  territoriesCodes: string[] | null = null;
  languagesCodes: string[] | null = null;
  metadataFieldsIncluded: DbMetadataUsageInfos[] | null = null;
  identityProfiles: DbDeliveryBroadcasterProfileIdentityInfos[] | null = null;
  metadataFieldsExclusions: DbMetadataFieldExclusionsInfos[] | null = null;
  metadataFieldsMappings: DbMetadataFieldMappingInfos[] | null = null;
  localizationTerritoryCodeHashTag: string | null = "#";
  emails: string[] | null = null;

  constructor(init?: Partial<DbDeliveryBroadcasterInfos>) {
    super();
    Object.assign(this, init);
  }
}
